import { render, staticRenderFns } from "./DuplicateTransaction.vue?vue&type=template&id=2a51584c&"
import script from "./DuplicateTransaction.vue?vue&type=script&lang=js&"
export * from "./DuplicateTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports